import { EntitySelect, EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import { WorkflowTeamSelectorDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import buildUrl from 'modules/core/lib/buildUrl'

import { MultiEntitySelectorComponent } from 'modules/workflows/components/Sidepanel/VariableSelectorTypes'

const TeamSelectorMulti: MultiEntitySelectorComponent = ({ value, onChange, error }) => {
  const { data, loading: teamsLoading } = useQuery(WorkflowTeamSelectorDocument)

  const availableTeams = data?.teams?.teamsConnection?.nodes || []
  const selectedTeams = value ? availableTeams.filter((team) => value.includes(team.id)) : []
  const selectedEntities = selectedTeams.map((team) => ({
    id: team.id,
    name: team.name,
    avatar: buildUrl(team.avatar),
  }))

  return (
    <EntitySelect
      label="Select teams"
      hideLabel
      loading={teamsLoading}
      entities={availableTeams.map(({ id, avatar, name }) => ({
        avatar: buildUrl(avatar),
        expanded: false,
        id,
        name,
      }))}
      notFoundSubtitle="No teams found"
      notFoundTitle="Teams not found"
      onGroupChange={() => {}}
      onItemExpandedChange={() => {}}
      onSelect={(selection: EntitySelectEntity[] | EntitySelectEntity | null) => {
        if (selection === null) {
          onChange(null)
        } else if (Array.isArray(selection)) {
          onChange(selection.length > 0 ? selection.map((s) => s.id) : null)
        } else {
          onChange([selection.id])
        }
      }}
      searchPlaceholder="Search teams..."
      selectedEntities={selectedEntities}
      selectedLabel="Selected"
      singleSelector={false}
      size="md"
      placeholder="Select teams..."
      selectedItemsCopy="Teams selected"
      groups={[]}
      selectedGroup="all"
      clearLabel="Clear"
      selectAllLabel="Select all"
      error={error}
    />
  )
}

export default TeamSelectorMulti
